// Cómo se menciona al cliente dentro de una frase cuando puede faltar su nombre.

/** Lo que se dice en lugar del nombre cuando no se conoce. */
export const CUSTOMER_FALLBACK_NAME = 'el cliente';

/** «de María» o, sin nombre, «del cliente» (la contracción que exige el español). */
export function ofCustomer(name: string): string {
    return name === CUSTOMER_FALLBACK_NAME ? 'del cliente' : `de ${name}`;
}

/** Mayúscula en la primera letra, para frases que pueden empezar con «el cliente». */
export function capitalizeFirst(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
}
